import { render, staticRenderFns } from "./RegisteredSpectator.vue?vue&type=template&id=520f06b6&"
import script from "./RegisteredSpectator.vue?vue&type=script&lang=js&"
export * from "./RegisteredSpectator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports